import { useConditionalRendering } from '@/shared/useConditionalRendering';
import { C08LinkListItemProps } from './C08LinkListItem.types';

export function GetLinkListItemModel(props?: C08LinkListItemProps) {
  const { fields } = props || {};

  const { renderLink } = useConditionalRendering();

  return {
    link: renderLink(fields?.Link),
  };
}
